module.exports = __webpack_public_path__ + "app-static/img/11.9bd71b24.png";